<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="debouncedHandleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    cancelText="关闭">
    <gift-company-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></gift-company-form>
  </j-modal>
</template>

<script>
import GiftCompanyForm from './GiftCompanyForm';
import { debounce } from 'lodash'; // 引入 lodash 的 debounce 方法

export default {
  name: 'GiftCompanyModal',
  components: {
    GiftCompanyForm
  },
  props: {
    appDataMap: {}
  },
  data () {
    return {
      title: '',
      width: 900,
      visible: false,
      disableSubmit: false
    };
  },
  methods: {
    add () {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.realForm.add();
      });
    },
    edit (record) {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.realForm.edit(record);
      });
    },
    close () {
      this.$emit('close');
      this.visible = false;
    },
    handleOk () {
      this.$refs.realForm.submitForm();
    },
    submitCallback () {
      this.$emit('ok');
      this.visible = false;
    },
    handleCancel () {
      this.close();
    }
  },
  created () {
    // 使用 debounce 包装 handleOk 方法
    this.debouncedHandleOk = debounce(this.handleOk, 500); // 500ms 内只触发一次
  }
};
</script>